// src/config/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAL0hnRNISrL4pWNycO607oI2yH3bTjpGI",
  authDomain: "parrotai-433712.firebaseapp.com",
  projectId: "parrotai-433712",
  storageBucket: "parrotai-433712.firebasestorage.app",
  messagingSenderId: "283170355185",
  appId: "1:283170355185:web:4ba505df54a7fdff7cf650",
  measurementId: "G-SV0J805EBB"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();

export default app;